import { Link } from "react-router-dom";
import { Linkedin, Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";
import { COMPANY, SERVICES } from "@/data/site";

const Col = ({ title, links }) => (
  <div>
    <h4 className="font-head uppercase tracking-[0.2em] text-[#FF5A00] text-xs font-700 mb-5">{title}</h4>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.label}>
          <Link to={l.to} className="text-[#94A3B8] hover:text-white transition-colors text-[15px]">{l.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer className="bg-[#0B192C] text-white relative overflow-hidden" data-testid="footer">
    <div className="absolute inset-0 noise opacity-[0.04] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 relative">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-9 h-9 bg-[#FF5A00] flex items-center justify-center">
              <span className="font-head font-black text-white text-2xl leading-none mt-1">C</span>
            </div>
            <div className="font-head font-black text-xl tracking-tight">CARGOWYN</div>
          </div>
          <p className="text-[#94A3B8] text-[15px] leading-relaxed max-w-xs mb-6">
            Founder-led cross-border freight brokerage based in {COMPANY.region}. Reliable Canada–US truck freight with a specialty in oversize & heavy-haul.
          </p>
          <div className="space-y-2 text-[#94A3B8] text-sm">
            <a href={COMPANY.phoneHref} className="flex items-center gap-2 hover:text-white"><Phone size={15} className="text-[#FF5A00]" />{COMPANY.phone}</a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-white"><Mail size={15} className="text-[#FF5A00]" />{COMPANY.email}</a>
            <div className="flex items-center gap-2"><MapPin size={15} className="text-[#FF5A00]" />{COMPANY.address}</div>
          </div>
        </div>
        <Col title="Services" links={SERVICES.map((s) => ({ label: s.title, to: `/services/${s.slug}` }))} />
        <Col title="Solutions" links={[{ label: "Construction", to: "/services" }, { label: "Industrial", to: "/services" }, { label: "Oversized Freight", to: "/services" }, { label: "Specialized", to: "/services" }]} />
        <Col title="Locations" links={[{ label: "Canada-Wide", to: "/services" }, { label: "Cross-Border US", to: "/services" }, { label: "North American", to: "/services" }, { label: "International", to: "/services" }]} />
        <Col title="Information" links={[{ label: "About", to: "/about" }, { label: "Contact", to: "/contact" }, { label: "Blog", to: "/blog" }, { label: "Get a Quote", to: "/quote" }]} />
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6">
        <p className="text-[#64748b] text-sm">© {new Date().getFullYear()} {COMPANY.name}. All rights reserved. · <Link to="/blog" className="hover:text-white">Privacy Policy</Link> · <Link to="/blog" className="hover:text-white">Terms of Use</Link></p>
        <div className="flex items-center gap-3">
          {[Linkedin, Facebook, Instagram].map((Icon, i) => (
            <a key={i} href="#" className="w-9 h-9 border border-white/15 flex items-center justify-center hover:bg-[#FF5A00] hover:border-[#FF5A00] transition-colors" data-testid={`social-${i}`}>
              <Icon size={16} />
            </a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);
